import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setPageTitle } from 'actions/header';
import { getConversation, submitMessage, createConversation, resetConversation } from 'actions/conversation';
import { getConversationParticipants } from '../Helpers';
import ConversationHeader from './ConversationHeader';
import ConversationMessages from './ConversationMessages';
import MessageForm from '../Form/MessageForm';
import { translate } from '@haldor/ui';
var ConversationPage = /*#__PURE__*/function (_Component) {
  /* Class setup */
  function ConversationPage(props) {
    var _this;
    _classCallCheck(this, ConversationPage);
    _this = _callSuper(this, ConversationPage, [props]);
    /* Lifecycle methods */
    _defineProperty(_this, "componentDidMount", function () {
      var id = _this.props.match.params.id;
      if (id != 'new') {
        _this.props.getConversation(id).then(function () {
          _this.setTitle();
          _this.setState({
            loading: false
          });
        });
      } else {
        if (_this.props.staged == null) {
          _this.props.history.replace("/conversations");
        } else {
          _this.setTitle();
          _this.setState({
            loading: false
          });
        }
      }
      window.addEventListener('resize', _this.onResize);
      _this.onResize();
    });
    _defineProperty(_this, "UNSAFE_componentWillReceiveProps", function (nextProps) {
      var id = nextProps.match.params.id;
      if (id != _this.props.match.params.id) {
        _this.setState({
          loading: true
        });
        _this.props.getConversation(id).then(function () {
          _this.setTitle();
          _this.setState({
            loading: false
          });
        });
      }
    });
    _defineProperty(_this, "setTitle", function () {
      var user = _this.props.user;
      var id = _this.props.match.params.id;
      var members = null;
      if (id != 'new') {
        members = getConversationParticipants(_this.props.conversation, user);
      } else {
        members = getConversationParticipants(_this.props.staged, user);
      }
      if (members == null) {
        return null;
      }
      var title = '';
      members.forEach(function (member, index) {
        if (member != null) {
          if (index > 0) {
            title += ', ';
          }
          if (member.membershipType == 'SECTION_OWNERS') {
            title += member.title + " (" + _this.props.translate('Staff') + ")";
            return true;
          }
          if (member.membershipType == 'GUARDIAN') {
            member.lastName = (member.lastName != null ? member.lastName : '') + ' (' + _this.props.translate('guardian') + ')';
          }
          title += member.firstName + ' ' + member.lastName;
        }
      });
      _this.props.setPageTitle(title);
    });
    _defineProperty(_this, "componentWillUnmount", function () {
      window.removeEventListener('resize', _this.onResize);
      _this.props.resetConversation();
    });
    /* Events */
    _defineProperty(_this, "submitMessage", function (values) {
      if (_this.props.conversation != null) {
        var lastMessage = _this.props.conversation.messages[_this.props.conversation.messages.length - 1];
        if (lastMessage == null) {
          values.parentId = null;
        } else {
          values.parentId = lastMessage.id;
        }
      } else {
        values.parentId = null;
      }
      return new Promise(function (resolve) {
        var user = _this.props.user;
        values.creator = user.id;
        values.senderId = user.id;
        values.senderType = 'USER';
        if (_this.props.match.params.id == 'new') {
          // Send message with a conversation object
          var conversation = _this.props.staged;
          values.id = 1;
          conversation.messages = [values];
          delete values.conversationID;
          conversation.memberships.forEach(function (membership) {
            delete membership.user;
            return membership;
          });
          _this.setState({
            loading: true
          });
          _this.props.createConversation(conversation, _this.props.activeStudent.id).then(function () {
            resolve(1);
            _this.props.history.replace("/conversations/".concat(_this.props["new"]));
          });
        } else {
          _this.props.submitMessage(values).then(function () {
            _this.setState({});
            resolve(1);
          });
        }
      });
    });
    _defineProperty(_this, "onResize", function () {
      var messages = document.querySelector('.conversation--wrapper');
      if (messages != null) {
        var height = 0;
        var body = document.querySelector('body');
        var footer = body.querySelector('.site-footer');
        var header = body.querySelector('.teams-header');
        var desktopHeader = body.querySelector('.desktop-header-spacing');
        var deviceMenu = body.querySelector('.footer-menu-bar-container');
        var deviceHeader = body.querySelector('.device-menu');
        height = window.innerHeight;
        if (footer != null) {
          height = height - footer.scrollHeight;
        }
        if (header != null) {
          height = height - header.scrollHeight;
        }
        if (desktopHeader != null) {
          height = height - desktopHeader.scrollHeight;
        }
        if (deviceMenu != null) {
          height = height - deviceMenu.scrollHeight - 15;
        }
        if (deviceHeader != null) {
          height = height - deviceHeader.scrollHeight;
        }
        messages.style.height = height - 25 + 'px';
      }
    });
    _this.state = {
      loading: true
    };
    return _this;
  }
  _inherits(ConversationPage, _Component);
  return _createClass(ConversationPage, [{
    key: "render",
    value: /* Render methods */
    function render() {
      var conversation = this.props.conversation;
      var disabled = false;
      if (this.props.match.params.id == 'new') {
        conversation = this.props.staged;
      }
      if (conversation != null && conversation.status == 'ARCHIVED') {
        disabled = true;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "page"
      }, /*#__PURE__*/React.createElement("div", {
        className: "conversation conversation--wrapper"
      }, /*#__PURE__*/React.createElement(ConversationHeader, {
        conversation: conversation
      }), /*#__PURE__*/React.createElement(ConversationMessages, {
        conversation: conversation
      }), /*#__PURE__*/React.createElement(MessageForm, {
        onSubmit: this.submitMessage,
        conversation: conversation,
        disabled: disabled
      })));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    conversation: state.Conversation.conversation,
    staged: state.Conversation.staged,
    "new": state.Conversation["new"],
    activeStudent: state.User.activeStudent,
    user: state.User.user,
    translate: translate(state.Languages.translations)
  };
}
export default withRouter(connect(mapStateToProps, {
  getConversation: getConversation,
  submitMessage: submitMessage,
  createConversation: createConversation,
  setPageTitle: setPageTitle,
  resetConversation: resetConversation
})(ConversationPage));